import { DialogController } from 'aurelia-dialog';
import { EntityController} from 'pages/entity/entity-controller';
import { autoinject } from 'aurelia-framework';
import { Item } from 'data/entities/entities';

@autoinject()
export class CloseTaskDialog {

	controller: EntityController;
	item: Item;
	itemStatus: number;
   
    constructor(private dialogController: DialogController) {
        this.dialogController.settings.lock = true;
    }

	activate(controller: EntityController) {
		this.controller = controller;
		this.item = controller.item;
		this.itemStatus = this.item.itemStatusId;
    }

	save() {
		this.item.itemStatusId = this.itemStatus;
		this.dialogController.ok();
	}
}